/**
 * WebAuthn / Passkey Client-Helfer
 * Nutzt @simplewebauthn/browser zur Kommunikation mit navigator.credentials.
 */
import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import api from './api';

export const isWebAuthnSupported = () => {
  return browserSupportsWebAuthn();
};

/**
 * Registriert einen neuen Passkey für den aktuell eingeloggten User.
 * @param {string} name – Anzeigename für das Gerät
 */
export async function registerPasskey(name = 'Mein Gerät') {
  const optionsResp = await api.post('/webauthn/register/begin');
  const options = optionsResp.data;

  // Browser-Prompt (Touch ID / Windows Hello / etc.)
  const credential = await startRegistration({ optionsJSON: options });

  const finishResp = await api.post('/webauthn/register/finish', {
    credential,
    name,
  });
  return finishResp.data;
}

/**
 * Loggt den User per Passkey ein. Gibt {access_token, user} zurück.
 */
export async function authenticateWithPasskey() {
  const optionsResp = await api.post('/webauthn/authenticate/begin');
  const options = optionsResp.data;
  const credential = await startAuthentication({ optionsJSON: options });
  const finishResp = await api.post('/webauthn/authenticate/finish', {
    credential,
  });
  return finishResp.data;
}

/**
 * Listet alle registrierten Passkeys des aktuellen Users.
 */
export async function listPasskeys() {
  const resp = await api.get('/webauthn/credentials');
  return resp.data;
}

export async function deletePasskey(id) {
  await api.delete(`/webauthn/credentials/${id}`);
}

export async function renamePasskey(id, name) {
  await api.patch(`/webauthn/credentials/${id}`, { name });
}
